import { FC } from "react";
import { Button } from "@chakra-ui/react";
import { TitleBlock } from "../TitleBlock";
import { UpperBlock, AboutTravelWrapper } from "./styles";

export const AboutTravel: FC = () => (
  <AboutTravelWrapper>
    <UpperBlock>
      <TitleBlock>Инфо о поездке</TitleBlock>
      <Button>Сохранить изменения</Button>
    </UpperBlock>
    
  </AboutTravelWrapper>
);
